export default "__VITE_ASSET__HxVG5sDH__"